import { useContext, useMemo } from 'react'
import { loanContext } from '../../../shared/LoanContext'

function useLoanEntities() {
  const { businesses, affiliates } = useContext(loanContext)

  return useMemo(() => {
    const accum = []

    businesses.forEach((business) => {
      const { guarantors, corporateGuarantors } = business

      accum.push(business)
      guarantors?.forEach((g) => accum.push(g))
      corporateGuarantors?.forEach((cg) => accum.push(cg))
    })

    return [...accum, ...affiliates]
  }, [businesses, affiliates])
}

export default useLoanEntities
